<!-- Document Information -->
<div class="content" *ngIf="isMspLoaded">
  <div class="container-fluid">
    <div class="page-title clearfix license-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> BILLING STATEMENT
      </h1>
    </div>
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
      <div class="page-title sub-title">
        <h5 class="float-left">{{doc_Title}}</h5>
        <div>
          <button pButton type="button" label="Confirm" class="ui-button-danger update" [disabled]="selectedNode == null || selectedNode.DocStatus !== mspPaymentDocumentStatusNumber['Unconfirm']" (click)="showConfirmPayment()"></button>
          <button pButton type="button" label="Add" icon="fa fa-plus" class="ui-button-danger update" (click)="showGeneratePaymentDocument('add')"></button>
          <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" [disabled]="selectedNode == null || selectedNode.DocStatus === mspPaymentDocumentStatusNumber['Close']" class="ui-button-danger update"
            (click)="showGeneratePaymentDocument('edit');">
          </button>
          <button pButton type="button" label="Delete" icon="fa fa-trash" class="ui-button-danger update"
            [disabled]="selectedNode == null || selectedNode.DocStatus !== mspPaymentDocumentStatusNumber['Unconfirm']" (click)="showConfirmDeleteDialog()"></button>
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions frozenTextAlignRight" #dtDoc [columns]="docTable_cols" [value]="docList" dataKey="DocId" [paginator]="true" [rows]="10" [scrollable]="true"
        (onEditInit)="onEditInit($event)" [(selection)]="selectedNode" selectionMode="single"
        [ngClass]="{'empty': docList.length === 0}">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
              <!-- <th *ngIf="col.field === 'Send'" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class" alignFrozen="right" pFrozenColumn>
                {{col.header}} {{col.field === 'Send'}} {{col.field === 'Status'}} 2
                <a class="ui-table-sort-icon" href="#" *ngIf="col.field === 'Send'"><i class="ui-sortable-column-icon pi pi-fw pi-sort"></i></a>
              </th> -->
              <th [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="i != 2 && i != 11 && i != 13"></p-sortIcon>
              </th>
            </ng-template>
            <th style="width:150px" alignFrozen="right" pFrozenColumn >Status</th>
            <th style="width:80px" alignFrozen="right" pFrozenColumn >Send</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" let-editing="editing">
          <tr [pSelectableRow]="rowData">
            <td style="width:70px" class="col-nowrap">
              <span>{{i+1}}</span>
            </td>
            <td style="width:150px" class="col-nowrap">
              <span><a routerLink="/management/payment/document-detail/{{rowData.CryptoDocId}}">{{rowData.DocNo}}</a></span>
            </td>
            <td style="width:55px" class="col-nowrap button">
              <button type="button" class="btn btn-outline-dark btn-sm" (click)="downloadRowDataDoc(rowData);"> <span class="pi pi-download"></span></button>
            </td>
            <td style="width:150px" class="col-nowrap">
              <span>{{ rowData.PaymentTypeStr }}</span>
            </td>
            <td style="width:150px" class="col-nowrap">
              <span>{{ rowData.PaymentType === PaymentTypeIndex.Monthly ? (rowData.MonthYear) : '-' }}</span>
            </td>
            <td style="width:150px" class="col-nowrap">
              <span>{{rowData.PaymentUsage}}</span>
            </td>
            <td style="width:150px" class="col-nowrap">
              <span>{{rowData.UnitPrice}}</span>
            </td>
            <td style="width:150px" class="col-nowrap">
              <span>{{rowData.PaymentPrice}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.GenerateTime}}</span>
            </td>
            <td style="width:220px" class="col-nowrap">
              <span>{{rowData.CreateAccount}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.CloseTime}}</span>
            </td>
            <td class="edit col-nowrap" pEditableColumn style="width:200px" [pEditableColumn]="rowData" [pEditableColumnField]="'Correspoding'" *ngIf="rowData.DocStatus !== mspPaymentDocumentStatusNumber['Unconfirm']">
              <p-cellEditor>
                <ng-template pTemplate="output">
                  {{rowData.CorrNo}}
                </ng-template>
                <ng-template pTemplate="input">
                  <input type="text" size="30" class="form-control pInputText" [ngModel]="rowData.CorrNo" pInputText
                    (ngModelChange)="correspodingOnChange(rowData, i)" (blur)="onBlur(rowData, i)">
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col-nowrap" style="width:200px" *ngIf="rowData.DocStatus === mspPaymentDocumentStatusNumber['Unconfirm']">
              <span></span>
            </td>
            <td style="width:120px" class="col-nowrap">
              <span>{{(rowData.IsFree) ? 'Y' : 'N'}}</span>
            </td>

            <td class="edit frozen" alignFrozen="right" pFrozenColumn pEditableColumn style="width:150px" *ngIf="rowData.DocStatus !== mspPaymentDocumentStatusNumber['Unconfirm']">
              <p-cellEditor>
                <ng-template pTemplate="output">
                  {{rowData.Status}}
                </ng-template>
                <ng-template pTemplate="input">
                  <p-select [options]="statusOptions" [ngModel]="rowData.Status" [style]="{'width':'100%'}" appendTo="body" (onShow)="statusInit(rowData, i)"
                    (onChange)="statusOnChange($event, rowData, i)">
                    <ng-template pTemplate="item" let-item>
                      {{item.label}}
                    </ng-template>
                    <ng-template pTemplate="selectedItem" let-item>
                      {{item.label}}
                    </ng-template>
                  </p-select>
                </ng-template>
              </p-cellEditor>
            </td>
            <td alignFrozen="right" pFrozenColumn class="frozen" style="width:150px" *ngIf="rowData.DocStatus === mspPaymentDocumentStatusNumber['Unconfirm']">
              Unconfirm
            </td>
            <td alignFrozen="right" pFrozenColumn style="width:80px" class="send text-align-center button">
              <button type="button" class="btn btn-outline-dark btn-sm" *ngIf="rowData.DocStatus !== mspPaymentDocumentStatusNumber['Unconfirm']" (click)="SendProPaymentDocumentMail(rowData.DocId)" [disabled]="PROPaymentSetting.Email.length == 0" [pTooltip]="PROPaymentSetting.Email.length == 0 ? 'Please set the receiving address.' : null"
                tooltipPosition="top"> <span class="fa fa-envelope"></span></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="docTable_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="container-fluid">
    <div class="page-filter clearfix border-b-radius-none" style="margin: 4em 0 0 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Account Activity</h5>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions" [paginator]="true" [rowsPerPageOptions]="[10,20]" [columns]="accountActivityTable_cols" [value]="accountActivityList" [paginator]="false" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
              <th *ngIf="i == 1" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
              <th *ngIf="i != 1" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-template>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.CreateTimeFormat}}</span>
            </td>
            <td style="width:220px" class="col-nowrap">
              <span>{{rowData.RegionName}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.ActionTypeStr}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span [ngClass]="{'positive': rowData.DisplayNodes> 0 ,'negative': rowData.DisplayNodes <0 }">{{rowData.DisplayNodes}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.Balance}}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="accountActivityTable_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td style="width:180px"></td>
            <td style="width:220px"></td>
            <td style="width:180px"></td>
            <td style="width:180px"><span>Node Bank</span></td>
            <td style="width:180px"><span>{{PROPaymentSetting.CurrentNPMBank}}</span></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="container-fluid">
    <div class="page-filter clearfix border-b-radius-none" style="margin: 4em 0 0 0">
      <div class="page-title sub-title flex-start">
        <h5 class="float-left">Predicted NPM Usage</h5>
        <i class="fa fa-exclamation-circle small" tooltipPosition="bottom" tooltipStyleClass="available two-line" pTooltip="The minimum usage has been included in this section's calculation."></i>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions" [columns]="predictedNPMUsageTable_cols" [value]="predictedNPMUsageList"
        [paginator]="false" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
              <th [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
            </ng-template>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.LastDeviceUsage}}</span>
            </td>
            <td style="width:250px" class="col-nowrap">
              <span>{{rowData.Growth}}</span>
            </td>
            <td style="width:300px" class="col-nowrap">
              <span>{{rowData.PredictedDeviceUsage}}</span>
            </td>
            <td style="width:200px" class="col-nowrap">
              <span>{{rowData.SettlementDate}}</span>
            </td>
            <td style="width:250px" class="col-nowrap">
              <div class="flex align">
                <span>{{rowData.PredictedBank}}</span>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of one month." *ngIf="PROPaymentSetting.CurrentNPMBank < (rowData.PredictedDeviceUsage * 1)"></i>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of two months." *ngIf="PROPaymentSetting.CurrentNPMBank < (rowData.PredictedDeviceUsage * 2) && PROPaymentSetting.CurrentNPMBank >= (rowData.PredictedDeviceUsage * 1)"></i>
                <i class="fa fa-exclamation-circle warning" tooltipPosition="bottom" tooltipStyleClass="warningTip" pTooltip="Your NPM is below the usage equivalent of three months." *ngIf="PROPaymentSetting.CurrentNPMBank < (rowData.PredictedDeviceUsage * 3) && PROPaymentSetting.CurrentNPMBank >= (rowData.PredictedDeviceUsage * 2)"></i>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="predictedNPMUsageTable_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- PDF 擷取用：必須常駐 DOM（p-drawer 關閉時內容不會渲染，會導致 captureBillingPDF 為 null） -->
<div class="billing-pdf-capture-host" aria-hidden="true">
  <app-document-pdf></app-document-pdf>
</div>

<!-- Confirm -->
<p-dialog header="Confirm" [(visible)]="dialogVisibility.confirm" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog distributeDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <ul class="alert alert-warning">
      <li>
        <span>Please confirm that the status of the Document <strong>#{{dialogInput.DocNo}}</strong>
          is to be changed from {{dialogInput.previousStatus}} to <strong>"<span>{{dialogInput.newStatus}}</span>"</strong></span>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="statusOnSave(this.rowDataStatus)"></button>
      <button type="button" pButton (click)="dialogVisibility.confirm=false" label="Cancel" class="p-button-secondary" (click)="statusOnCancel(this.rowDataStatusPrevious)"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm Payment -->
<p-dialog header="Confirm" [(visible)]="dialogVisibility.confirmPayment" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog distributeDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;">Please check the information below :</p>
    <ul class="alert alert-warning">
      <li>
        <span class="title">Company : </span>
        <span *ngIf="selectedNode">{{doc_Title}}</span>
      </li>
      <li>
        <span class="title">Purchase Type : </span>
        <span *ngIf="selectedNode">{{selectedNode.PaymentType === PaymentTypeIndex.Monthly ? 'Monthly' : 'Prepaid NPM'}}</span>
      </li>
      <li>
        <span class="title">Quantity (NPM) :</span>
        <span *ngIf="selectedNode">{{selectedNode.PaymentUsage}}</span>
      </li>
      <li>
        <span class="title">Unit Price (USD):</span>
        <span *ngIf="selectedNode">{{selectedNode.UnitPrice}}</span>
      </li>
      <li>
        <span class="title">Total Price :</span>
        <span *ngIf="selectedNode">{{selectedNode.PaymentPrice}}</span>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="confirmPayment()"></button>
      <button type="button" pButton (click)="dialogVisibility.confirmPayment=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Delete Confirm -->
<p-dialog header="Confirm" [(visible)]="dialogVisibility.confirmDelete" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="deletePayment()"></button>
      <button type="button" pButton (click)="dialogVisibility.confirmDelete=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>
